import PortalSDK from '@portal/sdk'

// 应用入口菜单对应的Key
export const ENTRY_KEY = ''
// 应用ID
export const APP_ID = 'ZkB6kEJ1n-10HJXO8IkBVEqCaoc0COisELr0'
// 管理应用ID
export const MGR_APP_ID = 'mpniGSR_S9HG6sf2Row4Vjkvk8JJ1hLOwFT5'

// 构造sdk实例
export const sdk = new PortalSDK({
  appId: APP_ID
})
